"use client";

import { Button, LinkButton } from "@procision-software/ui";
import { ChevronLeftIcon, HomeIcon } from "lucide-react";
import Image from "next/image";
import { useRouter } from "next/navigation";
import tabs from "~/assets/images/tabs.svg?resource";

export default function NotFound() {
  const router = useRouter();
  return (
    <div className="flex flex-1 flex-col gap-4 p-2 sm:flex-row sm:items-center sm:justify-center sm:gap-12 sm:p-12">
      <Image
        src={tabs}
        width={415}
        height={495}
        alt="Page not found"
        className="hidden h-auto max-w-full sm:block"
      />
      <div className="flex flex-col justify-center gap-4 sm:gap-12">
        <h1 className="whitespace-nowrap">404 Page not found</h1>
        <p>Sorry, we can&apos;t find the page you&apos;re looking for.</p>
        <div className="flex items-center gap-4">
          <Button
            variant="secondary"
            outline={true}
            onClick={(e) => {
              e.preventDefault();
              router.back();
            }}
            leftIcon={ChevronLeftIcon}
          >
            Go back
          </Button>
          <LinkButton variant="primary" outline={false} href="/" leftIcon={HomeIcon}>
            Go home
          </LinkButton>
        </div>
      </div>
    </div>
  );
}
